import { GenericButton } from "../../../components/UI-KIT/GenereicButton";
import { T } from "../../../styles/Theme";
import { CardContent, CardStyled, FooterContainer, PrimaryCard, SecondaryCard } from "../../../styles/Screens/Recommendations";
import TextValues from "../../../TextValues/index.json";
import styled from "styled-components";
import { CheckIconSmall } from "../../../assets/Icons/CheckIconSmall";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { EssentialsDataContext } from "../../../Contexts/EssentialsDataContext";
import TypingEffect from "../../../components/TypingEffect";
// import { useSwiper, useSwiperSlide } from "swiper/react";
import { ChatIcon } from "../../../assets/Icons/ChatIcon";
// import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ThreeDots from "../../../components/ThreeDots";
import { CHAT_BETA_URL } from "../../../env";
import { parseQuestionsAndAnswers } from "../../../utils/openai";

interface ICardSlider {
  data: any;
  onSelectService: any;
}

export const CardSlider = ({ data, onSelectService }: ICardSlider) => {

  let description = data.description ? data.description.split("--") : [];
  description = description.filter((el: any) => el !== "");

  const [finalForm] = useContext(EssentialsDataContext);
  const [chat, setChat] = useState("");

  // const swiper = useSwiperSlide();

  useEffect(() => {
    const config = {
      headers: {"Content-Type": "application/json",}
    };
    const bodyTest = JSON.stringify({
      data: parseQuestionsAndAnswers(finalForm),
      product: data.name,
      type: 1,
      number_of_characters: 280,
      emoji: true
    })
    axios.post(`${CHAT_BETA_URL}/predict/`, bodyTest, config)
      .then(response => {
        setChat(response.data.result);
      });
  }, []);

  return (
    <CardStyled>
      <PrimaryCard>
        <p style={{'fontSize': `${T.fontSizes.small}`, 'paddingBottom': '10px'}}>Artebianca</p>
        <p className="titleService">{data.name}</p>
        <ImageContainer>
          <img src={data?.images[0].image_url} alt="imagen" />
        </ImageContainer>
      </PrimaryCard>
      <CardContent>

        <SecondaryCard>
        <div className="match">Match: 100%</div>
        <ul>
          {description.map((value: any, i: number) => (
              <li className="down_arrow" key={i}>
                <span className="icon">
                  <CheckIconSmall />
                </span>
                <p>{value}</p>
              </li>
            )
          )}
        </ul>
      </SecondaryCard>
        <div className="buttonContainer">
          <GenericButton
            bg={T.secondary}
            c="white"
            onClick={() => {
              window.open(data?.links[0].link);
              onSelectService();
            }}
          >
            <span style={{'fontSize': '16px', 'color': '#000000'}}>
              {TextValues.buttons.goToService}
            </span>
          </GenericButton>
        </div>
      </CardContent>
      <FooterContainer>
        {(chat !== "") ? (
          <div className="footerContent">
            <ChatIcon/><TypingEffect text={chat} />
          </div>)
          : (
            <>
              <div className="footerContent"><ChatIcon/><ThreeDots /></div>
            </>
          )}
      </FooterContainer>
    </CardStyled>
  );
};

const ImageContainer = styled.div`
  width: 100%%;
  height: 100%%;
  display: flex;
  justify-content: center;
  align-items: left;
  // pagdding with good space
  padding: 20px 0 20px 0;
  
  img {
    width: 200px;
    height: 200px;
  }
`;